<template>
  <div class="team-intro-card wrap">
    <div :class="['team-intro-card__content', type === 'left' ? 'f-l' : 'f-r']">
      <img
        class="bg-img"
        src="@/assets/images/about-us/team-bg.png"
        alt=""
      >
      <div class="header">
        <img
          class="icon"
          src="@/assets/images/label.svg"
          alt=""
        >
        <span>ABOUT US</span>
      </div>
      <div class="title"><span class="label">{{label}}</span><span class="desc">{{desc}}</span></div>
      <div class="intro">
        <div class="blue-line"></div>
        <div class="intro-word">
          <slot name="intro"></slot>
        </div>
      </div>
    </div>
    <div :class="['team-intro-card__img', type === 'left' ? 'f-r' : 'f-l']">
      <slot name="img"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamIntroCard',
  props: {
    type: {
      type: String,
      default: 'left'
    },
    label: String,
    desc: String
  }
}
</script>

<style lang="less" scoped>
.team-intro-card {
  height: 535px;
  background-color: #f9faff;
  .f-l {
    float: left;
  }
  .f-r {
    float: right;
  }
  &__content {
    position: relative;
    width: calc(1200px - 502px);
    padding: 50px;
    padding-right: 40px;
    height: inherit;
    .bg-img {
      position: absolute;
      top: 0;
      right: 60px;
      height: inherit;
    }
    .header {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      font-size: 30px;
      line-height: 100%;
      color: #c3c5cc;
      .icon {
        width: 25px;
        height: 28px;
        margin-right: 23px;
      }
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 45px;
      line-height: 100%;
      color: #333;
      .label {
        font-size: 24px;
      }
      .desc {
        margin-left: 74px;
        font-size: 16px;
      }
    }
    .intro {
      position: relative;
      padding-left: 140px;
      .blue-line {
        position: absolute;
        top: 12px;
        left: 0;
        width: 110px;
        margin-right: 30px;
        border: 1px solid #437def;
      }
      .intro-word {
        line-height: 26px;
        text-align: justify;
        color: #6b6b6b;
        p {
          margin: 0;
          text-align: justify;
          text-indent: 2em;
          line-height: 24px;
        }
      }
    }
  }
  &__img {
    width: 502px;
    height: inherit;
  }
  &:after {
    content: "";
    clear: both;
    display: block;
  }
}
</style>
